import { authLocalData, authStore } from "@/stores/AuthStore";
import { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

export interface LoginFormValues {
  phrase: string[];
  imageBase64: string;
  login: string;
  password: string;
}

export const useFormLogin = () => {
  const { getImage } = authStore;
  const { valuePhrase, clearFields } = authLocalData;

  const dataForm = useForm<LoginFormValues>({
    defaultValues: {
      login: "",
      password: "",
      phrase: [],
    },
    mode: "onSubmit",
  });

  // Очищаем ошибку store при изменении поля

  const onSubmit: SubmitHandler<LoginFormValues> = async (data) => {
    if (data.phrase.length === 0) {
      authLocalData.addNewLocalError("Проверочное слово не может быть пустым");
      return;
    }
    if (data.phrase.length !== 5) {
      authLocalData.addNewLocalError("Проверочное слово должно быть из 5 символов, как на картинке");
      return;
    }

    const result = await authStore.login(data);
    if (result.error) {
      getImage();
      clearFields();
      dataForm.setValue("password", "");
    }
  };

  useEffect(() => {
    dataForm.setValue("phrase", valuePhrase, {
      shouldValidate: true,
    });
  }, [valuePhrase]);

  return { dataForm, onSubmit };
};
